<template>
  <div class="restaurantList">
    <div class="content">
      <div class="page-restaurant">
        餐厅信息
      </div>
      <ul>
        <li class="page-city" :class="{'text-underline': cityIndex == index}" v-for="(item, index) in city" :key="index">
          <a href="javascript:void(0);" @click="changeCity(index)">{{item}}</a>
        </li>
      </ul>
      <div v-for="(item, index) in restaurantInformation[cityIndex].restaurant" class="restaurant" :key="index">
        <div>{{item.name}}{{item.name_en}}</div>
        <div>
          <p>{{item.address}}</p>
          <p>{{item.address_en}}</p>
        </div>
        <div>
          <p>订餐电话：{{item.phone}}</p>
          <p>营业时间：{{item.time}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import list from './restaurantList';

export default {
  name: 'restaurantList',
  data() {
    return {
      restaurantInformation: list.restaurantInformation,
      city: list.city,
      cityIndex: 0,
    };
  },
  methods: {
    changeCity(index) {
      this.cityIndex = index;
    },
  },
};
</script>

<style scoped>
.content {
  padding: 24px 30px;
  background-color: #f5f5f5;
  margin: 20px auto;
}
.page-restaurant{
  color: #BA3F44;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}
.page-city{
  float: left;
  width: 47px;
}
.page-city a{
  color:#BA3F44;
}
.text-underline{
  text-decoration: underline;
}
.restaurant{
  border-bottom:1px solid #ECECEC;
  width: 100%;
  overflow: hidden;
}
.restaurant div{
  float: left;
  width: 471px;
  margin: 30px 0 20px;
  color: #A7A7A7;

}
.restaurant div:first-child,.restaurant div:last-child{
  width: 200px;
}
.restaurant div:first-child{
  color:#BA3F44;
}
</style>
<style lang="sass" scoped>
@import '../../../assets/css/mixins'

.restaurantList
  @include base-wrap
  overflow: hidden
  article
    min-height: 650px
    // background-color: #f5f5f5
    margin-top: 20px
    margin-bottom: 14px
</style>
